import styled from 'styled-components';

import { Checkbox } from '@dreryk/react-components';

export const StyledAllowAppointmentRequestsField = styled(Checkbox)`
   margin-right: auto;
`;
